// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"9f0f8179","268":"348f6bd5","282":"38277e14","538":"411187e5","563":"62c1f51d","668":"6b7f4c44","780":"81cc8d85","915":"a675c809"}[chunkId] + ".chunk.js";
};